import { search } from "../../BaseRepositoryComponents";
const path =
  process.env.REACT_APP_URL_API_ERP + process.env.REACT_APP_PATH_API_SHOP;

const pathProduto = path + "/v3/produto";

export function findProduto(
  empresa_cnpj,
  codigo,
  descricao,
  grupo,
  subgrupo,
  estoque,
  marketplace,
  fabricante,
  anuncio,
  pagina,
  quantidadePorPagina
) {
  //Adiciona todos os filtros "não nulos"
  let filters = codigo ? `&codigobarra=${codigo}` : "";
  filters += descricao ? `&procurar=${descricao}` : "";
  filters += grupo ? `&grupo_id=${grupo}` : "";
  filters += subgrupo ? `&subgrupo_id=${subgrupo}` : "";
  filters += estoque ? `&localestoque_id=${estoque}` : "";
  filters += marketplace ? `&marketplace=${marketplace}` : "";
  filters += fabricante ? `&fabricante_id=${fabricante}` : "";
  filters += anuncio && anuncio.id !== 0 ? `&anuncio=${anuncio}` : "";
  filters += pagina && pagina !== 0 ? `&page=${pagina}` : "";
  filters +=
    quantidadePorPagina && quantidadePorPagina > 0
      ? `&paginar=${quantidadePorPagina}`
      : "";

  return search(`${pathProduto}?empresa_cnpj=${empresa_cnpj}${filters}`);
}
